import axios from 'axios'

class PropertyService {
    static HOST = window.BASE_URL

    static validatePriceProperty (propertyId) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'GET',
                url: `${this.HOST}/validate-price-property/${propertyId}`
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

export default PropertyService
